import { all, fork } from "redux-saga/effects";

//auth
import authSaga from "./auth/saga";
import layoutSaga from "./layout/saga";
import organisationSaga from "./organisation/sagas";
import itemsSaga from "./items/sagas";
import partiesSaga from "./parties/sagas";
import vendorSaga from "./vendor/sagas";
import purchaseOrdersSaga from "./purchase-orders/sagas";
import salesInvoiceSaga from "./sales-invoice/sagas";
import salesReturnSaga from "./sales-return/sagas";
import purchaseInvoiceSaga from "./purchase-invoice/sagas";
import reportsSaga from "./reports/sagas";
import paymentInSaga from "./payment-in/sagas";
import paymentOutSaga from "./payment-out/sagas";
import cashBankSaga from "./cash-bank/sagas";
import expensesSaga from "./expenses/sagas";

export default function* rootSaga() {
  yield all([
    fork(authSaga),
    fork(layoutSaga),
    fork(organisationSaga),
    fork(itemsSaga),
    fork(partiesSaga),
    fork(vendorSaga),
    fork(purchaseOrdersSaga),
    fork(salesInvoiceSaga),
    fork(salesReturnSaga),
    fork(purchaseInvoiceSaga),
    fork(reportsSaga),
    fork(paymentInSaga),
    fork(paymentOutSaga),
    fork(cashBankSaga),
    fork(expensesSaga),
  ]);
}
